import uiConfig from '@onereach/ui-config';
// eslint-disable-next-line import-x/no-unresolved
import localOverrides from 'localOverrides';
// eslint-disable-next-line import-x/no-unresolved
import runningProjects from 'runningProjects';

import type { RemoteEnvironmentTarget } from '@/types/remote-environment-target.types';

import config from '../env.json';

type ExtendedConfig = typeof config & {
  REMOTE_ENVIRONMENT_ALLOWED_TARGETS?: RemoteEnvironmentTarget[];
  sentry: {
    debug: boolean;
    dsn: string;
    enabled: boolean;
    environment: string;
    errorReplaySessions: number;
    issuesUrl: string;
    maxBreadcrumbs: number;
    org: string;
    profilesRate: number;
    project: string;
    replaySessions: number;
    tracesSampleRate: number;
    url: string;
  };
};

export default uiConfig(config, localOverrides, runningProjects) as ExtendedConfig;
